import { useEffect, useState } from "react";
import axios from "axios";
import { IoSettingsOutline } from "react-icons/io5";

export const AutoApprovalToggle = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_V2_URL}/admin/check-auto-approval`)
      .then((res) => setEnabled(res.data.enabled))
      .catch(() => { });
  }, []);

  const onToggle = async () => {
    const message = enabled
      ? "Turn OFF auto approval?\nNew alerts will require manual approval."
      : "Turn ON auto approval?\nNew alerts will be approved automatically.";

    if (!window.confirm(message)) return;

    try {
      setLoading(true);
      const newValue = !enabled;

      await axios.post(`${process.env.REACT_APP_API_V2_URL}/admin/auto-approval`, {
        enabled: newValue,
      });

      setEnabled(newValue);
    } finally {
      setLoading(false);
    }
  };

return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-3">
        <IoSettingsOutline size={22} />
        <div className="leading-tight">
          <span className="text-sm font-medium">Auto Approval</span>
          <div className={`text-xs ${enabled ? "text-green-600" : "text-gray-500"}`}>
            {enabled ? "ON" : "OFF"}
          </div>
        </div>
      </div>

      <button
        onClick={onToggle}
        className={`relative w-12 h-6 rounded-full transition-colors duration-300
          ${enabled ? "bg-red-400" : "bg-gray-300"}
        `}
      >
        <span
          className={`absolute top-0.5 left-0.5 h-5 w-5 bg-white rounded-full shadow-md
            transform transition-transform duration-300
            ${enabled ? "translate-x-5" : "translate-x-0"}
          `}
        />
      </button>
    </div>
  );
};